import React, { useState } from "react";
import PropTypes from "prop-types";
import { Form, Input, Button, Select, message, Upload } from "antd";
import { useFormik } from "formik";
import { isEmpty } from "lodash";
import SizeCreationSchema from "../../../../Schemas/SizeCreationSchema"

import {
  createSize,
  updateSize,
} from "../../../../Services/SizeService";
import { useHistory } from "react-router-dom"; // useHistory for v5


function SizeCreationForm({
  data = {},
  callReFetch,
  isEditMode = false,
  onClose,
}) {
  const formik = useFormik({
    initialValues: {
      name: data.name || "",
      code: data.code|| "",
    },
    enableReinitialize: true,
    validationSchema: SizeCreationSchema,
  });

  const [loading, setLoading] = useState(false);
  const history = useHistory(); // useHistory for v5



  const handleSubmit = async () => {
    const values = formik.values;
    if (
      isEmpty(values.name) ||
      isEmpty(values.code)
    ) {
      message.error("Please insert all required data.");
      return;
    }

    try {
      if (!isEditMode) {
        await createSize(values);
        message.success("Size created successfully");
        onClose();
        callReFetch();
        formik.resetForm();
        // Redirect to the size list or wherever you want
      } else {
        const updatedSize = await updateSize(data._id, values);
        callReFetch();
        message.success(
          updatedSize?.data?.message || "Size updated successfully"
        );
        onClose(); // Close the modal
      }
    } catch (err) {
      console.error("Error: ", err);
      message.error(err?.response?.data?.message || "Something went wrong.");
    }
  };


  const { values } = formik;
  const titleText = isEditMode ? "Size Detail" : "Create Size";
  const submitButtonText = isEditMode ? "Update" : "Create";

  return (
    <div>
      <h2
        className="title"
        style={{ display: "flex", justifyContent: "center" }}
      >
        {titleText}
      </h2>
      <p style={{ display: "flex", justifyContent: "center" }}>
        Nama & Code Tidak boleh duplicate
      </p>
      <p style={{ display: "flex", justifyContent: "center" }}>
        Code hanya di antara 0 - 999
      </p>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Form
          layout="vertical"
          style={{
            maxWidth: "80vw",
            backgroundColor: "#F5F5F5",
            borderRadius: "8px",
            padding: "16px",
          }}
        >
          <Form.Item label="Name" required>
            <Input
              style={{ width: "100%" }}
              placeholder="Enter size name"
              onChange={(e) => formik.setFieldValue("name", e.target.value)}
              value={values.name}
            />
          </Form.Item>
          <Form.Item label="Code" required>
            <Input
              name="code"
              placeholder="Enter brand code"
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*$/.test(value)) {
                  // Allows only numbers (0-9)
                  const num = Number(value);
                  if (num >= 0 && num <= 999) {
                    formik.setFieldValue("code", value); // Set only if between 0-100
                  }
                }
              }}
              value={formik.values.code}
            />
          </Form.Item>{" "}
          <Form.Item style={{ textAlign: "center" }}>
            <Button
              type="primary"
              htmlType="button"
              className="bg-black"
              onClick={handleSubmit}
              style={{ marginRight: "10px" }}
            >
              {submitButtonText}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
}

SizeCreationForm.propTypes = {

};

export default SizeCreationForm;
